import { Card, CardBody } from "@heroui/react";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

import { CaptchaService, type CaptchaServiceStatus } from "../../lib/captcha";

const Timer = () => {
  const ref = useRef<HTMLElement | null>(null);

  useEffect(() => {
    let _timer = 0;

    const timer = setInterval(() => {
      _timer++;
      const text = (_timer + "").split("");
      text.splice(-1, 0, ".");
      if (ref.current) ref.current.innerText = text.join("") + "s";
    }, 100);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return <span ref={ref}></span>;
};

export const CaptchaStatusBar = () => {
  const [status, setStatus] = useState<CaptchaServiceStatus>("IDLE");

  useEffect(() => {
    const service = CaptchaService.get();

    setStatus(service.status);

    function handleStatus(status: CaptchaServiceStatus) {
      setStatus(status);
    }
    service.on("status", handleStatus);

    return () => {
      service.off("status", handleStatus);
    };
  }, []);

  // useEffect(() => {
  //   if (status === "IDLE") {
  //   }
  // }, [status]);

  return (
    <div className="toolbar-box -top-2.5 right-2.5 pointer-events-none">
      <motion.div
        className="pointer-events-auto"
        initial={{ x: "120%" }}
        animate={{ x: status === "WORK" ? 0 : "120%" }}
        transition={{ type: "spring", stiffness: 50 }}
      >
        <Card className="canvas-overlay-card">
          <CardBody>
            <p>Captcha running...</p>
            <p className="text-sm">
              Using{" "}
              <a
                href="https://altcha.org/captcha/"
                target="_blank"
                rel="noreferrer"
                className="underline"
              >
                Altcha
              </a>{" "}
              &bull; {status === "WORK" && <Timer />}
            </p>
          </CardBody>
        </Card>
      </motion.div>
    </div>
  );
};
